import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { media } from '../styles/breakpoints';

import Icon from '../IconWithLabel';

class ShareLink extends Component {

    input = null;

    onCopyClick = () => {
      this.input.setAttribute('readonly', false);
      this.input.setAttribute('contenteditable', true);
      this.input.style.fontSize = '12px';
      var range = document.createRange();
      this.input.select();
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      this.input.setSelectionRange(0, 999999);
      try {
        // copy text
        document.execCommand( 'copy' );
        this.input.blur();
      }
      catch ( err ) {
        alert( 'please press Ctrl/Cmd+C to copy' );
      }
      window.getSelection().removeAllRanges();
      this.input.setAttribute('readonly', true);
      this.input.setAttribute('contenteditable', false);
      this.input.style.fontSize = '12px';
    };

    render() {
        const StyledActionBarItem = styled.div`
            &.stolo-actionbar-item {
                cursor: copy;
                overflow: hidden;
    
                & input {
                    border: none;
                    color: ${props => props.theme.palette.blueGrey[500]};
                    font-size: ${props => props.theme.fontSizes[6]};
                    display: block;
                    background: transparent;
                    margin: 0 0 0 ${props => props.theme.fontSizes[10]};
                    padding: 0px;
                    max-width:  ${props => props.theme.space[16]};
                    
                    ${media.tweak600up`
                        font-size: ${props => props.theme.fontSizes[5]};
                        max-width:  ${props => props.theme.space[15]};
                    `}
                    &:focus,
                    &:active
                    {
                      border: none;
                    }
                }
            }
        `;
        return (
            <StyledActionBarItem className='stolo-actionbar-item' >
                <Button onClick={this.onCopyClick} component='div' >
                    <Icon
                        iconProps={this.props.iconProps}
                        label={this.props.label}
                        direction={this.props.direction}
                    />
                </Button >
                <input
                    ref={element => {
                        this.input = element;
                    }}
                    type={'text'}
                    value={this.props.shareTarget}
                    readOnly
                />
            </StyledActionBarItem >
        );
    }
}

export default ShareLink;



// WEBPACK FOOTER //
// ./src/components/sharing/ShareLinkIcon.js